import { createClient, SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = (import.meta as any).env.VITE_SUPABASE_URL
const supabaseAnonKey = (import.meta as any).env.VITE_SUPABASE_ANON_KEY

// Create a null supabase client if credentials are missing
let supabase: SupabaseClient | null = null

if (supabaseUrl && supabaseAnonKey) {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
      storageKey: 'sb-auth-token',
      flowType: 'pkce',
      debug: true
    }
  })
  
  // Enhanced OAuth session detection
  if (window.location.hash.includes('access_token') || 
      window.location.search.includes('code=') || 
      window.location.search.includes('type=oauth')) {
    console.log('[SUPABASE] OAuth session detected in URL, processing authentication...')
  }
} else {
  console.warn('Supabase credentials not configured. Running in demo mode.')
}

// Export a non-null supabase client for compatibility
export { supabase }